import Vue from 'vue';

const state = {
	meetingLocations: [],
	meetingLocations_loading: false
};

const getters = {
	meetingLocations: state => {
		return state.meetingLocations;
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Meeting Locations...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/meetingLocations`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	add({ commit, dispatch, rootState }, meetingLocation) {
		console.log('Adding New Meeting Location...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/meetingLocations`, meetingLocation)
				.then(resp => {
					commit('ADD_SUCCESS', meetingLocation);
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error saving Meeting Location');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, meetingLocation) {
		console.log('Updating Meeting Location...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/meetingLocations/${meetingLocation.id}`, meetingLocation)
				.then(resp => {
					commit('EDIT_SUCCESS', meetingLocation);
					dispatch('get');
					resolve(meetingLocation);
				})
				.catch(err => {
					console.log('Error updating Meeting Location');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, meetingLocation) {
		console.log('Deleting Meeting Location...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/meetingLocations/${meetingLocation.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', meetingLocation);
					dispatch('get');
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Meeting Location');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.meetingLocations_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.meetingLocations_loading = false;
		state.meetingLocations = data;
	},
	GET_FAILURE(state, error) {
		state.meetingLocations_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.meetingLocations.push(data);
	},
	EDIT_SUCCESS(state, data) {
		let found = state.meetingLocations.find(pr => pr.id === data.id);
		if (found != null) {
			found = data;
		}
	},
	DELETE_SUCCESS(state, data) {
		const index = state.meetingLocations.indexOf(data);
		state.meetingLocations.splice(index, 1);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
